export default __webpack_public_path__ + "static/media/world.a2703484.mp4";